import { render, staticRenderFns } from "./InactiveApplicant.vue?vue&type=template&id=e76e1f62&lang=html&"
import script from "./InactiveApplicant.vue?vue&type=script&lang=js&"
export * from "./InactiveApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports